import * as yup from 'yup';
import { REQUIRED_FIELD_MESSAGE } from '../constants';

export const loginSchema = yup.object().shape({
  username: yup.string().required().email(),
  password: yup.string().required(),
});

export const transferSchema = yup.object().shape({
  name: yup.string().required(REQUIRED_FIELD_MESSAGE),
  iban: yup
    .string()
    .required(REQUIRED_FIELD_MESSAGE)
    .matches(
      /([a-zA-Z]{2})\s*\t*(\d{2})\s*\t*(\d{4})\s*\t*(\d{4})\s*\t*(\d{2})\s*\t*(\d{10})/,
      'Invalid IBAN, for example ES11 2222 3333 44 55555555555'
    ),
  amount: yup
    .number()
    .required(REQUIRED_FIELD_MESSAGE)
    .typeError(REQUIRED_FIELD_MESSAGE),
});

export type UserInfoDto = {
  userName: string;
  userLastName: string;
};

export const userInfoSchema = yup.object().shape({
  userName: yup.string().required(REQUIRED_FIELD_MESSAGE),
  userLastName: yup.string().required(REQUIRED_FIELD_MESSAGE),
});

export const customPhraseSchema = yup.object().shape({
  customPhrase: yup
    .string()
    .matches(/^\S+\s+\S+.*$/gm, 'You must enter at least two words')
    .test({
      message: () => 'The phrase must be shorter than seven words',
      test: (value) => {
        const wordsArray = (value as string)
          .trim()
          .split(/\s+/)
          .filter((word) => word.length > 0);
        return wordsArray.length <= 7;
      },
    }),
});
